// extracted by mini-css-extract-plugin
export default {"loginWrapper":"login_loginWrapper__XNMsW","loginBtn":"login_loginBtn__EJfA+"};